/**
 * Created by SH: 20/02/2020
 */

import { ReelEngineController } from '../../core/reel/ReelEngineController';
import { GameSetting } from '../../core/setting/GameSetting';
import { BeheadedReelEngine } from './BeheadedReelEngine';
import { BeheadedSymbol } from './symbol/BeheadedSymbol';

export class BeheadedEngineView extends ReelEngineController {
    protected isAvalanching: boolean;
    protected attentionStop: boolean = false;
    protected _engine: BeheadedReelEngine;

    public get engine(): BeheadedReelEngine {
        return this._engine;
    }

    public get AllSymbols(): BeheadedSymbol[] {
        return this._symbolContainer.children as BeheadedSymbol[];
    }

    public get topSymbol(): BeheadedSymbol {
        return this.AllSymbols[0];
    }
    public get bottomSymbol(): BeheadedSymbol {
        return this.AllSymbols[this.AllSymbols.length - 1];
    }

    public get windowTopSymbol(): BeheadedSymbol {
        return this.AllSymbols[this.overflowAmount];
    }
    public get windowBottSymbol(): BeheadedSymbol {
        return this.AllSymbols[this.AllSymbols.length - (1 + this.overflowAmount)];
    }
    public get symbolConfAmount(): number {
        return this.windowConfAmount + this.overflowAmount;
    }
    public get AllWindowSymbols(): BeheadedSymbol[] {
        return this.AllSymbols.filter((sym) => {
            return Math.max(...sym.posID) >= 0 && Math.min(...sym.posID) < this.symbolConfAmount;
        });
    }

    public get startEase(): any {
        if (this.isAvalanching) return this.config.EASING.DROP;
        return GameSetting.isFastSpin ? this.config.EASING.FAST_START : this.config.EASING.START;
    }

    public get stopDuration(): number {
        // if (this.isQuickStop) return this.config.DURATION.QUICK_STOP;
        if (GameSetting.isFastSpin) return this.config.DURATION.FAST_STOP;
        else if (this.attentionStop) return this.config.DURATION!.ATTENTION_STOP!;
        return this.config.DURATION.STOP;
    }

    public get stopDelay(): number {
        // if (this.isQuickStop) return this.config.DELAY.QUICK_STOP;
        if (GameSetting.isFastSpin) return this.config.DELAY.FAST_STOP;
        return this.config.DELAY.STOP;
    }

    protected createNewSymbol(id: number, symbolName: string, state?: string, type?: number): BeheadedSymbol {
        return new BeheadedSymbol(id, symbolName, state, this.windowConfAmount);
    }
}
